/*
  Motureo (W6): przełącznik trybu ciemnego. Stan: localStorage['motureo-theme'] = 'light' | 'dark';
  bez wpisu decyduje prefers-color-scheme (z nasłuchem zmiany, dopóki klient nie wybierze ręcznie).
  Atrybut data-theme na <html> ustawia wcześniej snippets/motureo-theme-init.liquid; tu: kliknięcie,
  aria-pressed i title przycisków, kolor paska przeglądarki (meta theme-color) oraz krótkie przejście kolorów
  (CSS, tylko bez prefers-reduced-motion).
*/
(function () {
  var KEY = 'motureo-theme';
  var root = document.documentElement;
  var media = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;
  var timer = 0;
  // pasek przeglądarki: jasny = kolor wiersza górnego nagłówka (Horizon: data-theme-color, ustawia go też przy przyklejeniu)
  var DARK_BAR = '#0f1519'; // --motureo-dark-page

  function saved() {
    try {
      var v = localStorage.getItem(KEY);
      return v === 'light' || v === 'dark' ? v : null;
    } catch (e) {
      return null;
    }
  }

  function apply(theme, animate) {
    if (animate) {
      root.classList.add('motureo-theme-anim');
      clearTimeout(timer);
      timer = setTimeout(function () { root.classList.remove('motureo-theme-anim'); }, 200);
    }
    root.setAttribute('data-theme', theme);
    var dark = theme === 'dark';
    var header = document.querySelector('[data-theme-color]');
    var meta = document.head.querySelector('meta[name="theme-color"]');
    if (header && !header.hasAttribute('data-motureo-light-color')) {
      header.setAttribute('data-motureo-light-color', header.getAttribute('data-theme-color'));
    }
    var bar = dark ? DARK_BAR : header ? header.getAttribute('data-motureo-light-color') : '';
    if (header) header.setAttribute('data-theme-color', bar);
    if (meta) meta.setAttribute('content', bar);
    document.querySelectorAll('.motureo-theme-toggle').forEach(function (b) {
      b.setAttribute('aria-pressed', dark ? 'true' : 'false');
      var t = b.getAttribute(dark ? 'data-title-light' : 'data-title-dark');
      if (t) b.title = t;
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target instanceof Element ? e.target.closest('.motureo-theme-toggle') : null;
    if (!b) return;
    var next = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    try { localStorage.setItem(KEY, next); } catch (err) { /* tryb prywatny: tylko ta strona */ }
    apply(next, true);
  });

  if (media) {
    var follow = function () { if (!saved()) apply(media.matches ? 'dark' : 'light', true); };
    if (media.addEventListener) media.addEventListener('change', follow);
    else if (media.addListener) media.addListener(follow);
  }

  apply(root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light', false);
})();
